export const editModeHeaderTranslationJP = {
  EditModeHeader: {
    text1: '再編集モードで「配信No: {{deliveryId}}」を編集中です。',
    text2: '配信設定は編集できません。',
    button: '通常モードに戻る',
  },
};
